import withPageContainer from '../shared/page-container/with-page-container';
import withIntl from '../shared/intl-hoc';

export default Main => withPageContainer(withIntl(Main), { name: 'Alerts analytics' });



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/alerts-analytics/wrap-main.js